import * as order from '@/views/Order/constants'
import * as budget from '@/views/Budget/constants'
import service_order_request from '@/views/ServiceOrder/RequestConstants'
import * as equipment from '@/views/Equipment/constants'
import rental_payments from '@/views/Rental/PaymentsConstants'
import rental from '@/views/Rental/RentalConstants'
import * as exchange from '@/views/Exchange/constants'

export const CONSTANTS = Object.freeze({
  order,
  budget,
  service_order_request,
  equipment,
  rental_payments,
  rental,
  exchange
})
